import { apiClient } from "../../services";

export const checkAuth = function () {
  return apiClient.get("/auth/check");
};

export const loginApi = function ({ idToken }) {
  return apiClient.post("/auth/loginFb", { idToken });
};
